<template>
  <div class="scroll-container">
    <div class="scroll-header">
      <img src="@/assets/images/xiaoxi-6 2@2x.png" alt="最新新闻" class="news-icon" />
    </div>
    <div class="scroll-content" @mouseenter="pauseScroll" @mouseleave="resumeScroll">
      <div class="scroll-track" :style="trackStyle" :class="{ 'paused': isPaused }">
        <span 
          v-for="(item, index) in displayItems" 
          :key="index" 
          class="news-item"
          @click="handleItemClick(item)"
        >
          {{ item.chineseTitle }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsScrollList } from "@/api/api";

export default {
  name: "NewsScroll",
  data() {
    return {
      scrollText: [],
      animationDuration: 28,
      itemSpacing: 50,
      isPaused: false,
    };
  },
  computed: {
    displayItems() {
      return [...this.scrollText, ...this.scrollText];
    },
    trackStyle() {
      if (this.scrollText.length === 0) return {};
      
      const itemCount = this.scrollText.length;
      const totalWidth = itemCount * 300;
      const totalSpacing = this.itemSpacing * itemCount;
      const trackWidth = totalWidth + totalSpacing;
      
      return {
        width: `${trackWidth * 2}px`,
        animationDuration: `${this.animationDuration * 2}s`,
      };
    },
  },
  created() {
    this.getSyLbNewList();
  },
  methods: {
    getSyLbNewList() {
      // 滚动条已独立成表：/news/scroll/list，自带排序
      getNewsScrollList({ pageNum: 1, pageSize: 20 }).then((response) => {
        const rows = response.rows || [];
        this.scrollText = rows.map((item) => ({
          ...item,
          chineseTitle: item.scrollText || item.title || '',
          id: item.newsId
        }));
      });
    },

    // 暂停滚动
    pauseScroll() {
      this.isPaused = true;
    },
    
    // 恢复滚动
    resumeScroll() {
      this.isPaused = false;
    },
    
    // 处理点击事件
    handleItemClick(item) {
      if (item.url) {
        // 如果有URL，则跳转
        window.open(item.url, '_blank');
      }
    },
  },
};
</script>

<style scoped>
.scroll-container {
  display: flex;
  align-items: center;
  background: #fff;
  min-height: 44px;
  padding: 0;
  overflow: hidden;
  position: relative;
}

.scroll-header {
  display: flex;
  align-items: center;
  padding: 0 16px;
  z-index: 2;
  flex-shrink: 0;
}

.news-icon {
  width: 22px;
  height: 22px;
}

.scroll-content {
  flex: 1;
  overflow: hidden;
  position: relative;
  cursor: pointer;
}

.scroll-track {
  display: flex;
  align-items: center;
  animation: scroll-left linear infinite;
  white-space: nowrap;
}

.scroll-track.paused {
  animation-play-state: paused;
}

.news-item {
  display: inline-block;
  font-family: AlibabaPuHuiTi_3_55_Regular;
  font-size: 16px;
  color: #5E6166;
  line-height: 22px;
  margin-right: 50px;
  padding: 0 8px;
  border-radius: 15px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.news-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: #1890ff; /* 添加悬停颜色变化 */
  transform: translateY(-1px); /* 添加轻微悬停效果 */
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

/* 响应式设计 */
@media (max-width: 960px) {
  .scroll-container {
    padding: 8px 0;
    min-height: 44px;
    max-width: 100%;
    border-radius: 8px;
    box-sizing: border-box;
  }
  .news-item {
    font-size: 14px;
    line-height: 22px;
    margin-right: 24px;
  }
  .scroll-header {
    padding: 0 10px;
    background: linear-gradient(90deg, #fff 70%, rgba(255,255,255,0));
  }
  .scroll-content {
    min-width: 0;
  }
  .news-icon {
    width: 20px;
    height: 20px;
  }
}
</style>